import React from "react";
import { Header, Footer } from ".";
import { Outlet } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { CustomRotateDevice } from "../components";

const MainLayout = () => {
  const isLandscape = useMediaQuery({ query: "(orientation: landscape)" });
  return (
    <main>
      {!isLandscape ? (
        <CustomRotateDevice />
      ) : (
        <>
          <Header />
          <div className={`tc-body-wrapper pt-0 rx-main-layout`}>
            <div className="tc_main_version_wrapper">
              <span className="tc_main_version_content">
                Test version {process.env.REACT_APP_VERSION}
              </span>
            </div>
            <div className="tc-body fog_body_white">
              <Outlet />
            </div>
          </div>
          {/* <Footer /> */}
        </>
      )}
    </main>
  );
};

export default MainLayout;
